import Api from "..";
import { PublicLc } from "../../dtos/lc";
import transform from "../../service/transform";

export default class LcApi extends Api {
  constructor() {
    super("lc");
  }

  public async get(): Promise<PublicLc[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError("PublicLc entry list is not an array.");

    return await Promise.all(
      data.map(async (value) => await transform(PublicLc)(value)),
    );
  }
}
